module.exports = __webpack_public_path__ + "static/media/universalExpanders.e2c1a052.png";